import Rx from 'rxjs';
import { push } from 'react-router-redux';
import { combineEpics } from 'redux-observable';

import * as constAction from 'root/actionConstants';
import * as vehiculosActions from 'modules/vehiculos/action';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import { request } from 'core/generalFunctions';

const { ajax } = Rx.Observable;

export const getEpic = (action$, store) =>
  action$.ofType(constAction.VEHICULOS_GET_BY_ID).switchMap(action =>
    ajax(request(action))
      .map(result => vehiculosActions.setState({ vehiculo: result.response }))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getByIdEpic = (action$, store) =>
  action$.ofType(constAction.VEHICULOS_GET).switchMap(action =>
    ajax(request(action))
      .map(result => vehiculosActions.setState({ lista: result.response }))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const setEpic = (action$, store) =>
  action$
    .ofType(constAction.VEHICULOS_SET)
    .throttleTime(2000)
    .switchMap(action =>
      ajax(request(action))
        .map(result => vehiculosActions.actualizarState(result.response))
        .concat(Rx.Observable.of(push('/dashboard/vehiculos')))
        .concat(Rx.Observable.of(generalActions.snackbar_show('Vehiculo guardado')))
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const deleteEpic = (action$, store) =>
  action$
    .ofType(constAction.VEHICULOS_DELETE)
    .throttleTime(500)
    .switchMap(action =>
      ajax(request(action))
        .mapTo(generalActions.snackbar_show('Vehiculo eliminado'))
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const seleccionarChoferEpic = (action$, store) =>
  action$
    .ofType(constAction.VEHICULOS_SELECCIONAR_CHOFER)
    .debounceTime(500)
    .switchMap(action =>
      ajax(request(action))
        .map(({ response }) => generalActions.seleccionador_setLista('_chofer', response))
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const seleccionarDispositivoEpic = (action$, store) =>
  action$
    .ofType(constAction.VEHICULOS_SELECCIONAR_DISPOSITIVO)
    .debounceTime(500)
    .switchMap(action =>
      ajax(request(action))
        .map(({ response }) => generalActions.seleccionador_setLista('_dispositivo', response))
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export default combineEpics(getEpic, setEpic, deleteEpic, getByIdEpic, seleccionarChoferEpic, seleccionarDispositivoEpic);



// WEBPACK FOOTER //
// src/modules/vehiculos/epics.js